const thumbnailOpinionsSwiper = new Swiper('.opinions__thumbnail-swiper', {
    slidesPerView: 4,
    direction: 'vertical',
    grabCursor: true,
    breakpoints: {
        992: {
            direction: 'horizontal',
            slidesPerView: 2,
        },
        1200: {
            direction: 'horizontal',
            slidesPerView: 4,
        },
    },
});

const mainOpinionsSwiper = new Swiper('.opinions__main-swiper', {
    slidesPerView: 1,
    effect: 'fade',
    thumbs: {
        swiper: thumbnailOpinionsSwiper,
    },
});

const logosSwiper = new Swiper('.logos__swiper', {
    slidesPerView: 1.5,
    loop: true,
    allowTouchMove: false,
    centeredSlides: true,
    speed: 6500,
    autoplay: {
        delay: 0,
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 6,
        },
    },
});
